import { Search } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { Autocomplete, Card, CardContent, CircularProgress, Container, FormControl, Grid, MenuItem, Select, TextField } from '@mui/material'
import ArgonBox from 'components/ArgonBox'
import ArgonTypography from 'components/ArgonTypography'
import KomponenList from 'examples/Lists/KomponenList'
import { getDataWithResponse } from 'global/getFunc'
import { postDataWithResponse } from 'global/postFunc'
import React, { useEffect, useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import Komponen from './Komponen'

const Belanja = () => {
    return (
        <Routes>
            <Route path="" element={<Data />} />
            <Route path="komponen" element={<Komponen />} />
        </Routes>
    )
}

const Data = () => {
    const [data, setData] = useState([])
    const [listTA, setListTA] = useState([])
    const [loading, setLoading] = useState(false)

    const date = new Date();
    const tahun = date.getFullYear()

    const [listOpd, setListOpd] = useState([])
    const [listOpd2, setListOpd2] = useState([])
    const [opd, setOpd] = useState({})

    const [tahunAnggaran, setTahunAnggaran] = useState(tahun)

    useEffect(() => {
        setListOpd2([])
        listOpd.forEach((opdx) => {
            let data = { label: opdx.nama_pd, value: opdx.kd_pd }
            setListOpd2(listOpd2 => [...listOpd2, data])
        })
        console.log(listOpd2);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listOpd])

    const reqOpd = () => {
        setLoading(true)
        postDataWithResponse(
            '/opd/filter',
            {
                jenis: '',
                nama: '',
            },
            null,
            (res) => {
                console.log(res);
                setListOpd(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    useEffect(() => {
        reqOpd()
        reqTA()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const reqTA = () => {
        setLoading(true)
        getDataWithResponse(
            // `/admin-opd/perencanaan-opd/${decodedUser.tahun_anggaran}/${decodedUser.kd_pd}`,
            `/get-ta`,
            null,
            (res) => {
                console.log(res);
                setListTA(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }
        );
    }

    const reqBelanja = () => {
        setLoading(true)
        postDataWithResponse(
            '/komponen-belanja/off-site',
            {
                ta: tahunAnggaran,
                kd_pd: opd.kd_pd
                // pagination: pagination,
                // globalFilter: globalFilter,
                // sorting: sorting,
                // columnFilter: columnFilter
            },
            null,
            (res) => {
                console.log(res);
                setData(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    useEffect(() => {
        reqBelanja()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tahunAnggaran, opd])

    return (
        <Container sx={{ my: 10 }}>
            <ArgonBox mt={2}>
                <Grid container spacing={2} my={2}>
                    <Grid item xs={12} xl={12}>
                        <ArgonTypography>DAFTAR PEKERJAAN</ArgonTypography>
                    </Grid>
                </Grid>
            </ArgonBox>
            <ArgonBox mt={2}>
                <Card>
                    <CardContent>
                        <Grid container spacing={2} mt={1}>
                            <Grid item xs={12} xl={5}>
                                <ArgonBox mb={1}>
                                    <FormControl fullWidth>
                                        {/* <InputLabel id="demo-simple-select-standard-label">Age</InputLabel> */}
                                        <Select
                                            placeholder="Select year"
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={tahunAnggaran}
                                            onChange={(e) => {
                                                setTahunAnggaran(e.target.value)
                                            }}
                                        >
                                            {
                                                listTA.map((ta, index) => (
                                                    <MenuItem key={index} value={ta.ta}>{ta.ta}</MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} xl={5}>
                                <ArgonBox mb={1}>
                                    <Autocomplete
                                        id="combo-box-demo"
                                        options={listOpd}
                                        fullWidth
                                        required
                                        getOptionLabel={(option) => option.nama_pd}
                                        onChange={(event, newValue) => {
                                            newValue !== null && setOpd(newValue)
                                        }}
                                        onInputChange={(event, newInputValue) => {
                                            newInputValue === "" && setOpd({})
                                            // newInputValue.length > 7 && reqDpt()
                                        }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    required: true,
                                                    endAdornment: (
                                                        <>
                                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                }}
                                            />
                                        )}
                                    />
                                </ArgonBox>
                            </Grid>
                            <Grid item xs={12} xl={2}>
                                <LoadingButton
                                    fullWidth
                                    color='info'
                                    variant='contained'
                                    size="small"
                                    startIcon={<Search />}
                                    type='submit'
                                    loading={loading}
                                    sx={{
                                        verticalAlign: 'bottom'
                                    }}
                                >
                                    Search
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </ArgonBox>
            {
                loading ?
                    (
                        (
                            <ArgonBox align="center" mt={3}>
                                <CircularProgress />
                            </ArgonBox>
                        )
                    )
                    :
                    (
                        <ArgonBox pt={3}>
                            <KomponenList
                                title="Paket Pekerjaan"
                                listData={data}
                                to='/belanja/komponen'
                                showOpd={true}
                                showLastUpdate={false}
                            />
                        </ArgonBox>
                    )
            }

        </Container>
    )
}
export default Belanja